import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  catchError,
  lastValueFrom, Observable,
  retry
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { ButtonFuncResponse } from '../interfaces/ButtonsFuncResponse';
import { LogoLibraryResponse } from '../interfaces/logoLibraryResponse';
import { handleError } from '../utils/generic-utils';
import {PlaylistGroupsResponse, PlaylistsResponse} from "../interfaces/playlistsResponse";

@Injectable({
  providedIn: 'root',
})
export class ConfigDataService {
  endpoint: string = environment.performTVApi.url;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    responseType: 'json',
  });
  retry = 0;

  private _logo_library: LogoLibraryResponse[];
  private _playlistGroups: PlaylistGroupsResponse[];
  private _playlists: PlaylistsResponse[];
  private _buttons_funcs: ButtonFuncResponse;

  constructor(private http: HttpClient, private _snackBar: MatSnackBar) {}

  get logoLibrary() {
    return this._logo_library;
  }

  get playlistGroups() {
    return this._playlistGroups;
  }

  get playlists() {
    return this._playlists;
  }

  get buttonsFuncs() {
    return this._buttons_funcs;
  }

  async getButtonsFunc() {
    let api = `${this.endpoint}/remote-control/buttons-functions`;
    await lastValueFrom(this.http
      .get(api, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(handleError)))
      .then((res: ButtonFuncResponse) => {
        this._buttons_funcs = res;
      })
      .catch((error) => {
        this.openSnackBar(error.message, 'Ok');
      });
  }

  async getLogosList() {
    let api = `${this.endpoint}/logos`;
    await lastValueFrom(
      this.http
        .get(api, { headers: this.headers, responseType: 'json' })
        .pipe(retry(this.retry), catchError(handleError))
    )
      .then((res: LogoLibraryResponse[]) => {
        this._logo_library = res;
      })
      .catch((error) => {
        this.openSnackBar(error.message, 'Ok');
      });
  }

   async getPlaylistGroupsList(): Promise<void> {
    let api = `${this.endpoint}/playlist-groups`;
    await lastValueFrom(
        this.http
        .get<PlaylistGroupsResponse[]>(api, { headers: this.headers, responseType: 'json' })
        .pipe(retry(this.retry), catchError(handleError))
    )
      .then((res: PlaylistGroupsResponse[]) => {
        this._playlistGroups = res;
       })
      .catch((error) => {
        this.openSnackBar(error.message, 'Ok');
      });
  }

  async getPlaylists(venueId: string): Promise<PlaylistsResponse[]> {
    let api = `${this.endpoint}/playlist-group/${venueId}/playlists`;
    return await lastValueFrom(
        this.http
        .get<PlaylistsResponse[]>(api, { headers: this.headers, responseType: 'json' })
        .pipe(retry(this.retry), catchError(handleError))
    )
      .then((res: PlaylistsResponse[]) => {
        return res;
       })
      .catch((error) => {
        this.openSnackBar(error.message, 'Ok');
        return null
      });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 6000,
    });
  }

}
